import * as React from 'react';
import { AppContext, IAppContext } from './contexts/AppContext';

import './Ribbon.scss';

//@ts-ignore
import { icon, IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './CertMetrics.scss';

interface ICertMetricsProps {
}

interface ICertMetrics {
}

export default class CertMetrics extends React.PureComponent<ICertMetricsProps, ICertMetrics> {
    static contextType = AppContext;
    constructor(props: ICertMetricsProps) {
        super(props);
        this.state = { showCertSelectorPopup: false };
    }

    render() {

        return (
            <div className="comp_Cert">
                <p>
                    <FontAwesomeIcon icon={faCircleInfo as IconProp} /> To view CompTIA Certifications, please visit our <a target="_blank" href="https://www.certmetrics.com/comptia/public/verification.aspx">CertMetrics site</a>.
                </p>
            </div>
        )
    }
}